import {useParams} from 'react-router-dom';
import {
  FeatureFlagEnum,
  ModuleEnum,
  PermissionOperationEnum,
} from 'src/api/ProactApiClient';
import {ContentWrapper} from 'src/app/layout/ContentWrapper';
import {DeviceDocumentTitle} from 'src/pages/Modules/Inspections/shared/deviceHelpers';
import {DeviceForm} from 'src/pages/Modules/Inspections/shared/DeviceForm';
import {routeRegistry} from 'src/pages/RouteRegistry';
import {PathUtility} from 'src/shared/constants/PathBuilder';
import useSetDocumentTitle from 'src/shared/hooks/useSetDocumentTitle';

export const DeviceEditPage = () => {
  useSetDocumentTitle(DeviceDocumentTitle);
  const {deviceId} = useParams();

  return (
    <ContentWrapper featureFlag={FeatureFlagEnum.Inspections}>
      <DeviceForm id={Number(deviceId)} mode="edit" />
    </ContentWrapper>
  );
};

// Register the route with the new system
routeRegistry.registerPageRoute({
  backNavigation: 'form',
  path: PathUtility.DevicesEdit(':deviceId'),
  element: <DeviceEditPage />,
  module: ModuleEnum.Inspections,
  operation: PermissionOperationEnum.Update,
  isPrivate: true,
});
